import {Component, Input} from '@angular/core';
import {EventResponse} from '../../../../../../../../@shared/models/response.module';
import {formatTimeDMYHHMM} from '../../../../../../../../@core/utils/utils.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EditEvent} from './components/edit-event/edit-event';
import {EditEventImages} from './components/edit-event-images/edit-event-images';
import {EventsService} from '../../../../../../../../@shared/services/events-service';
import {AQH_EVE_0} from '../../../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-manage-event-overview',
  standalone: false,
  templateUrl: './manage-event-overview.html',
  styleUrl: './manage-event-overview.css'
})
export class ManageEventOverview {
  @Input() event: EventResponse
  protected readonly formatTimeDMYHHMM = formatTimeDMYHHMM;

  constructor(private modalService: NgbModal,
              private eventService: EventsService) {
  }

  openEditEventModal() {
    let modalRef = this.modalService.open(EditEvent, {centered: true, size: 'xl'});
    modalRef.componentInstance.event = this.event;
    modalRef.result.then((result) => {
      if (result) {
        this.getEvent()
      }
    }).catch((error) => {
      // Handle dismissal if needed
    });
  }

  openEditImagesModal() {
    let modalRef = this.modalService.open(EditEventImages, {centered: true, size: 'lg'});
    modalRef.componentInstance.event = this.event;
    modalRef.result.then((result) => {
      if (result) {
        this.getEvent()
      }
    }).catch((error) => {
      // Handle dismissal if needed
    });
  }

  getEvent() {
    let params: AQH_EVE_0 = {
      event_id: Number(this.event.event_id)
    }
    this.eventService.getEvents(params).subscribe((res) => {
      this.event = res.data[0];
      console.log("Mange event: ", this.event)
    })

  }
}
